import PropTypes from 'prop-types';
import { useState } from 'react';

import * as CritereOperators from '../CritereOperateurs.js';

const AVAILABLE_OPERATORS = [
  CritereOperators.LOWER_THAN,
  CritereOperators.EQUAL,
  CritereOperators.GREATER_THAN,
];
const OPERATOR_LABEL_BY_ID = {
  LOWER_THAN: 'Inférieur à',
  EQUAL: 'Égal à',
  GREATER_THAN: 'Supérieur à',
};

const IntegerField = ({ name, defaultValue, onChange }) => {
  const [valid, setValid] = useState(true);
  const handleInputChanged = (event) => {
    setValid(
      () =>
        event.target.validity.valid &&
        (!event.target.value || /^[0-9]+$/.test(event.target.value)),
    );
  };
  return (
    <>
      <select
        className="critere-operator"
        defaultValue={defaultValue.operateur ?? CritereOperators.EQUAL}
        onChange={(event) =>
          onChange({
            valeur: defaultValue.valeur,
            operateur: event.target.value,
          })
        }
      >
        {AVAILABLE_OPERATORS.map((operateur) => (
          <option value={operateur} key={operateur}>
            {OPERATOR_LABEL_BY_ID[operateur]}
          </option>
        ))}
      </select>
      <input
        type="number"
        className={`critere-input ${!valid ? 'invalid' : null}`}
        value={defaultValue.valeur || ''}
        name={name}
        // on utilise l'event onInput (au lieu de onChange) pour tester la validité du champ car rentrer des caractères autre que [0-9] ne déclenche pas l'event onChange
        onInput={handleInputChanged}
        onChange={(event) =>
          onChange({
            valeur: event.target.value ? parseInt(event.target.value) : null,
            operateur: defaultValue.operateur,
          })
        }
        pattern="[0-9]*"
        step={1}
      />
      {!valid ? (
        <div className="critere-input-error">
          La valeur doit être un nombre entier.
        </div>
      ) : null}
    </>
  );
};
IntegerField.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.shape({
    valeur: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    operateur: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
};

export default IntegerField;
